import { Col, Row, Typography } from "antd";
import { QueryClientProvider } from "@tanstack/react-query";
import type { TFunction } from "i18next";
import { useTranslation } from "react-i18next";

import ActionLogDrawerAsync from "@/v1/components/common/ActionLogDrawerAsync";
import { AuditLogButton } from "@/v1/components/pages/CommandHubView/styledComponents";
import { CreateConnectionButton } from "./components/create-connection";
import { ConnectionsOverview } from "./components/connections-overview";
import { queryClient } from "./client";
import { IUser } from "@/v1/types";

const getTexts = (t: TFunction) => ({
  title: t("title"),
  actionLogDrawer: {
    title: t("actionLogDrawer.title"),
    viewAuditLogs: t("actionLogDrawer.viewAuditLogs"),
  },
  noUserSelected: t("noUserSelected"),
});

export const BankingConnections = ({ user }: { user: IUser | undefined }) => {
  const { t } = useTranslation("Banking");
  const texts = getTexts(t);

  return (
    <QueryClientProvider client={queryClient}>
      <div className="mt-4">
        <Row align="middle" justify="space-between">
          <Typography.Title level={3}> {texts.title} </Typography.Title>
          <Row align="middle" gutter={12} justify="end">
            {user && (
              <>
                <Col>
                  <CreateConnectionButton user={user} />
                </Col>
                <Col>
                  <ActionLogDrawerAsync
                    title={texts.actionLogDrawer.title}
                    modelName="banking_connection"
                    recordIds={[user.publicId]}
                    renderButton={({ onClick }) => (
                      <AuditLogButton type="link" onClick={onClick}>
                        {texts.actionLogDrawer.viewAuditLogs}
                      </AuditLogButton>
                    )}
                  />
                </Col>
              </>
            )}
          </Row>
        </Row>

        <div className="mt-2">
          {user ? (
            <ConnectionsOverview customerId={user.publicId} />
          ) : (
            <p>{texts.noUserSelected} </p>
          )}
        </div>
      </div>
    </QueryClientProvider>
  );
};
